import { useTranslation } from 'react-i18next';

import TextField from '../../../../../../components/HookFormControls/TextField';
import { i18nNS } from '../../../../../../i18n';
import useTitle from './vm';

export interface TitleProps {
  className?: string;
}

const Title = ({ className }: TitleProps) => {
  const { t } = useTranslation([i18nNS.TIMER]);

  const { formMethods, onSubmit, handleChange } = useTitle();
  const { handleSubmit, control } = formMethods;

  return (
    <form noValidate onSubmit={handleSubmit(onSubmit)} className={className}>
      <TextField
        control={control}
        name="title"
        hideHelperText
        onChange={handleChange}
        fullWidth
        placeholder={t('untitled_timer', { ns: i18nNS.TIMER })}
      />
    </form>
  );
};

export default Title;
